import type { ApiError } from '@/shared/api/client';
import type { BankAccount } from '@/shared/api/resources';
import { BankCodeSelect } from '@/shared/ui/BankCodeSelect';
import { Field } from '@/shared/ui/Field';
import { Select } from '@/shared/ui/Select';

import { fieldErrorOf } from '../../shared/fieldError';

/**
 * Conta bancaria do tomador, com os mesmos campos e as mesmas regras da conta da
 * corretora: banco, tipo, agencia e conta so com numeros, digito numero ou X. O
 * banco vem da relacao do Banco Central (P-TOM-C1), e nao mais digitado.
 */
export function FinancialBankAccountFields({
  value,
  onChange,
  apiError,
}: {
  value: BankAccount;
  onChange: (conta: BankAccount) => void;
  apiError: ApiError | null;
}) {
  function set(campo: keyof BankAccount, valor: string) {
    onChange({ ...value, [campo]: valor });
  }

  return (
    <div className="grid gap-4 sm:grid-cols-3">
      <BankCodeSelect
        required
        value={value.bank_code}
        error={fieldErrorOf(apiError, 'bank_account.bank_code')}
        onChange={(codigo) => set('bank_code', codigo)}
      />
      <Select
        label="Tipo de conta"
        required
        placeholder="Selecione"
        options={[
          { value: 'corrente', label: 'Conta corrente' },
          { value: 'poupanca', label: 'Conta poupanca' },
        ]}
        value={value.account_type}
        error={fieldErrorOf(apiError, 'bank_account.account_type')}
        onChange={(event) => set('account_type', event.target.value)}
      />
      <div />
      <Field
        label="Agencia"
        required
        inputMode="numeric"
        maxLength={5}
        value={value.agency}
        error={fieldErrorOf(apiError, 'bank_account.agency')}
        onChange={(event) => set('agency', event.target.value)}
      />
      <Field
        label="Digito da agencia"
        maxLength={1}
        value={value.agency_digit}
        error={fieldErrorOf(apiError, 'bank_account.agency_digit')}
        onChange={(event) => set('agency_digit', event.target.value)}
      />
      <div />
      <Field
        label="Conta"
        required
        inputMode="numeric"
        maxLength={20}
        value={value.account}
        error={fieldErrorOf(apiError, 'bank_account.account')}
        onChange={(event) => set('account', event.target.value)}
      />
      <Field
        label="Digito da conta"
        maxLength={1}
        value={value.account_digit}
        error={fieldErrorOf(apiError, 'bank_account.account_digit')}
        onChange={(event) => set('account_digit', event.target.value)}
      />
    </div>
  );
}
